// extracted by css-extract-rspack-plugin
export default {"rivers":"FeaturesSection-module__rivers__uv3LX8O"};